import Skyflow from 'skyflow-js';
const useCollectListeners = (props, element) => {
    if (props.onChange) {
        element.on(Skyflow.EventName.CHANGE, props.onChange);
    }
    if (props.onBlur) {
        element.on(Skyflow.EventName.BLUR, props.onBlur);
    }
    if (props.onFocus) {
        element.on(Skyflow.EventName.FOCUS, props.onFocus);
    }
    if (props.onReady) {
        element.on(Skyflow.EventName.READY, props.onReady);
    }
};
export default useCollectListeners;
//# sourceMappingURL=index.js.map